import React, { forwardRef } from 'react';
import { styled } from '@linaria/react';

const Typo = styled.p<TypographyProps>`
  text-align: ${(props) => (props.align ? props.align : 'left')};
  font-size: ${(props) => (props.variant === 'title' ? '20px' : '16px')};
  color: ${(props) =>
    props.color
      ? props.color
      : props.variant === 'title'
      ? '#434343'
      : '#8A8988'};
  font-weight: ${(props) =>
    props.variant === 'description'
      ? 400
      : props.fontWeight
      ? props.fontWeight
      : 600};
  line-height: ${props => props.variant === 'description' ? '22px' : '140%'};
  max-width: ${(props) => (props.maxWidht ? props.maxWidht + 'px' : 'unset')};
  @media screen and (min-width: 768px) {
    font-size: ${(props) => (props.variant === 'title' ? '28px' : '16px')};
    font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 600)};
  }
`;

export interface TypographyProps {
  variant: 'base' | 'title' | 'description';
  align?: 'left' | 'center' | 'right';
  color?: string;
  fontWeight?: number;
  maxWidht?: number;
  children: String;
  theme?: any;
}

const Typography = forwardRef<HTMLDivElement, TypographyProps>(
  ({ ...props }: TypographyProps, ref) => {
    return <Typo {...props}>{props.children}</Typo>;
  }
);

Typography.defaultProps = {
  variant: 'title',
  align: 'left',
  children: '',
};
export { Typography };
